import { IMaterial } from "src/types";

export interface IFileCollection {
  items: IMaterial[];

  /**
   * This function will append items to the collection, with the
   * optional parameter to replace them if the desire is to perform
   * an update on an existing record in the collection.
   */
  add: (item: IMaterial, pos?: number) => IMaterial[];

  /**
   * Locate and remove an item by memory reference.  Similar to
   * the `find` method this will only locate a record if using
   * the same variable reference you retrieved or added to the
   * collection previously.  If looking for a content match, use
   * `match`
   */
  remove: (item: IMaterial) => number | undefined;
}

export function FileCollection(initial: IMaterial[]): IFileCollection {
  const items: IMaterial[] = [...initial];

  const add = (item: IMaterial): IMaterial[] => {
    remove(item);
    items.push(item);
    return items;
  };

  const remove = (item: IMaterial) => {
    for (let x = 0; x < items.length; x++) {
      if (items[x].fieldPath === item.fieldPath && items[x].fileName === item.fileName) {
        items.splice(x, 1);
        return x;
      }
    }
  };

  return { items, add, remove };
}